// extracted by mini-css-extract-plugin
export default {"ratingDesc":"MediaLinksConfig-ratingDesc-bd4cc679c87c2a7456422488e93c5d76"};